import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-proxy-label',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './proxy-label.component.html',
  styleUrls: ['./proxy-label.component.scss']
})
export class ProxyLabelComponent {
  proxyText = 'PROXY';
  
}
